import {instance} from './index';

export async function getFeatures() {
  return instance()
    .get('directory/features')
    .then(response => response.data.data);
}
